import React from 'react';
import PropTypes from 'prop-types';

// Import the specific display components
import ThinkingDisplay from './commandDisplays/ThinkingDisplay';
import ResourceDisplay from './commandDisplays/ResourceDisplay';
import AgentMessageDisplay from './commandDisplays/AgentMessageDisplay';
import DefaultCommandDisplay from './commandDisplays/DefaultCommandDisplay';

const CommandRenderer = ({ command }) => {
  if (!command) return null;

  // Determine which component to render based on command.type
  switch (command.type) {
    case 'thinking':
      return <ThinkingDisplay command={command} />;
    case 'resource':
    case 'resource_update_signal': // Handle signals like resources for display
      return <ResourceDisplay command={command} />;
    case 'agent_message':
    case 'system': // Treat system messages like agent messages for now
    case 'error': // Maybe create a specific ErrorDisplay later
      return <AgentMessageDisplay command={command} />;
    case 'internal_command':
    case 'command': // Generic commands
    default:
      // Optionally log unexpected types
      // if (!['internal_command', 'command'].includes(command.type)) {
      //   console.warn("Rendering unknown command type with default:", command.type, command);
      // }
      return <DefaultCommandDisplay command={command} />;
  }
};

CommandRenderer.propTypes = {
  command: PropTypes.object.isRequired,
};

export default React.memo(CommandRenderer); // Memoize as it renders based on command prop